import { registerComponent } from '@gig/magic-common';
import { SessionSummaryManagerComponent } from './session-summary-manager.js';

var SessionSummaryManager = registerComponent(SessionSummaryManagerComponent);

export { SessionSummaryManager };
